import LanguageCode from '../types/language';

export const NATIVE_LANGUAGE_NAMES: Record<LanguageCode, string> = {
	en: 'English',
	es: 'español',
	fr: 'français',
	hy: 'հայերեն',
	ar: 'العربية',
	zh: '中文',
	de: 'Deutsch',
	it: 'italiano',
	ru: 'Русский',
	tl: 'Tagalog',
	vi: 'Tiếng Việt',
	so: 'Soomaali',
};

export function getNativeLanguageName(language: string): string {
	return (
		NATIVE_LANGUAGE_NAMES[language as LanguageCode] ??
		new Intl.DisplayNames([language], { type: 'language' }).of(language) ??
		language
	);
}
